import { Flex, Box } from '@chakra-ui/react';

import { FlowHealthTable } from './flow-health-table';
import { GroupBy } from '../../../../shared/group-by';
import { BreakdownBy } from '../../../../shared/breakdown-by';
import { Metrics } from '../../../../shared/metrics';
import { useContext } from 'react';
import { setFilter } from '@/store/reports/filter';
import { useDispatch } from 'react-redux';
import { ReportSelectionContext } from '@/contextProviders/ReportSelection';
import { useKFlags } from '@/hooks/use-k-flags';
import { EmptyDataWrapper } from '@/pages/reports/ats-reports/components/empty-data-wrapper';

export const Table = ({
  data = [],
  filters = {},
  renderTitle = undefined,
  isReadOnly = false,
  isPrintView = false,
  customData = undefined,
  customBreakdownChange = undefined,
  filterParams = undefined,
  hideLinks = undefined,
  isFullScreen = false,
  tile = {},
  isStaticReport = false,
  onSortChange = (_sortState) => {},
  isEditMode = false,
  skipLocalStorage = false,
  tableColStyles = {},
  onTableColDataChange = undefined,
  initialTableColData = undefined,
}) => {
  const dispatch = useDispatch();
  const { feReportsV3 } = useKFlags();
  const { consumer } = useContext(ReportSelectionContext);
  const onChangeBreakDown = (selected) => {
    dispatch(setFilter({ type: 'break_down', value: selected?.id }));
  };

  const onChangeGroupBy = (selected) => {
    dispatch(setFilter({ type: 'group_by', value: selected?.id }));
  };

  const onChangeMetrics = (selected) => {
    dispatch(setFilter({ type: 'metrics', value: selected?.id }));
  };

  const metricFields = ['contacted', 'opened', 'replied', 'interested'];
  const getFieldWithData = () => {
    const dataToUse = customData || data;
    if (!dataToUse?.length) return 'contacted';
    for (const field of metricFields) {
      if (dataToUse.some((row) => row[field] > 0)) return field;
    }
    return 'contacted';
  };

  return (
    <Box h={'calc(100% - 35px)'}>
      {consumer === 'DEFAULT' && (
        <Flex
          justifyContent={renderTitle ? 'space-between' : 'end'}
          w="100%"
          position="sticky"
          top="0"
          zIndex="6"
          bg="white"
        >
          {renderTitle && renderTitle?.()}
          <Flex
            gap="8px"
            mt={!customData && '20px'}
            position="relative"
            zIndex="99"
            flexDir="row-reverse"
            flexShrink={0}
            mr={isPrintView ? '0' : isEditMode ? '55px' : '35px'}
            mb="12px"
          >
            <Metrics
              isEditMode={isEditMode}
              selected={filters?.metrics}
              onChange={(option) =>
                customBreakdownChange
                  ? customBreakdownChange('metrics', option)
                  : onChangeMetrics(option)
              }
            />
            <BreakdownBy
              isPortal={!isFullScreen}
              isEditMode={isEditMode}
              options={[
                { id: null, label: 'None' },
                { id: 'recruiter', label: 'Recruiter' },
                { id: 'school', label: 'School' },
                { id: 'source', label: 'Source' },
              ]}
              selected={filters?.break_down}
              onChange={(option) =>
                customBreakdownChange
                  ? customBreakdownChange('group_by_2', option)
                  : onChangeBreakDown(option)
              }
            />
            <GroupBy
              isEditMode={isEditMode}
              isPortal={!isFullScreen}
              selected={filters?.group_by}
              onChange={(option) =>
                customBreakdownChange
                  ? customBreakdownChange('group_by_1', option)
                  : onChangeGroupBy(option)
              }
            />
          </Flex>
        </Flex>
      )}
      <EmptyDataWrapper data={customData || data} field={getFieldWithData()}>
        <FlowHealthTable
          isReadOnly={isReadOnly}
          isStaticReport={isStaticReport}
          filters={filters}
          data={customData || data}
          filterParams={filterParams}
          hideLinks={hideLinks}
          isFullScreen={isFullScreen}
          tile={tile}
          onSortChange={onSortChange}
          onTableColDataChange={onTableColDataChange}
          initialTableColData={initialTableColData}
          skipLocalStorage={skipLocalStorage}
          tableColStyles={{
            ...tableColStyles,
            hideReorderColumns: feReportsV3,
          }}
          isEditMode={isEditMode}
        />
      </EmptyDataWrapper>
    </Box>
  );
};
